import { Link, useLocation } from "react-router-dom";
import tiktokIcon from "./tiktok.png";
import facebookIcon from "./facebook.png";

export default function Footer({ onJoin }) {
  const y = new Date().getFullYear();
  const { pathname } = useLocation();
  const onContactPage = pathname === "/contact";

  const homeHref = onContactPage ? "/#hero" : "#hero";
  const aboutHref = onContactPage ? "/#about" : "#about";

  const handleJoinClick = (e) => {
    e.preventDefault();
    if (onJoin) onJoin();
  };

  return (
    <footer
      style={{
        padding: "3rem 0",
        borderTop: "1px solid var(--hairline)",
        background: "color-mix(in srgb, var(--c3) 30%, white 70%)",
      }}
    >
      {/* TOP SECTION */}
      <div
        className="container"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          marginBottom: "2.5rem",
        }}
      >
        <div
          style={{
            fontWeight: 900,
            fontSize: "1.8rem",
            color: "var(--ink)",
            letterSpacing: "1px",
          }}
        >
          BeFitFriends
        </div>

        <p
          style={{
            fontSize: "1.2rem",
            fontWeight: 600,
            color: "var(--ink-muted)",
            marginTop: "0.4rem",
          }}
        >
          Find your fitness community
        </p>

        

        {/* Social icons */}
        <div style={{ display: "flex", gap: "12px", marginTop: "14px" }}>
          {/* Instagram */}
          <a
            href="https://www.instagram.com/befitfriendsapp/"
            aria-label="Instagram"
            style={{
              display: "grid",
              placeItems: "center",
              width: 36,
              height: 36,
              borderRadius: 10,
              background: "#fff",
              border: "1px solid var(--hairline)",
            }}
          >
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none">
              <rect x="3" y="3" width="18" height="18" rx="5" stroke="#1f2e36" />
              <circle cx="12" cy="12" r="4.5" stroke="#1f2e36" />
              <circle cx="17.5" cy="6.5" r="1.25" fill="#1f2e36" />
            </svg>
          </a>

          {/* Twitter */}
          <a
            href="https://x.com/BeFitFriendsX"
            aria-label="Twitter"
            style={{
              display: "grid",
              placeItems: "center",
              width: 36,
              height: 36,
              borderRadius: 10,
              background: "#fff",
              border: "1px solid var(--hairline)",
            }}
          >
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none">
              <path
                d="M20.5 7.5c-.7.3-1.5.6-2.3.6.8-.5 1.4-1.2 1.7-2.2-.8.5-1.7.9-2.6 1-1.7-1.9-5-.7-5 
                2.1 0 .3 0 .6.1.8-3.3-.1-6.2-1.7-8.1-4.1-.4.8-.2 2 .5 2.6-.6 
                0-1.1-.2-1.6-.4 0 1.5 1 2.8 2.4 3.1-.4.1-.9.2-1.3.1.4 
                1.3 1.7 2.2 3.1 2.2C5.7 13.9 4.2 14.3 3 
                14c1.4.9 3 1.4 4.8 1.4 5.8 0 9-5 8.7-9.5.7-.5 1.3-1.1 1.7-1.8z"
                fill="#1f2e36"
              />
            </svg>
          </a>

          {/* YouTube */}
          <a
            href="https://www.youtube.com/@BeFitFriends"
            aria-label="YouTube"
            style={{
              display: "grid",
              placeItems: "center",
              width: 36,
              height: 36,
              borderRadius: 10,
              background: "#fff",
              border: "1px solid var(--hairline)",
            }}
          >
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none">
              <rect x="3" y="6" width="18" height="12" rx="3" stroke="#1f2e36" />
              <path d="M11 10l4 2-4 2v-4z" fill="#1f2e36" />
            </svg>
          </a>

          {/* TikTok */}
          <a
            href="https://www.tiktok.com/@befitfriends"
            aria-label="TikTok"
            style={{
              display: "grid",
              placeItems: "center",
              width: 36,
              height: 36,
              borderRadius: 10,
              background: "#fff",
              border: "1px solid var(--hairline)",
            }}
          >
            <img src={tiktokIcon} alt="TikTok" style={{ width: 18, height: 18 }} />
          </a>

          {/* Facebook */}
          <a
            href="https://www.facebook.com/profile.php?id=61583789395965"
            aria-label="Facebook"
            style={{
              display: "grid",
              placeItems: "center",
              width: 36,
              height: 36,
              borderRadius: 10,
              background: "#fff",
              border: "1px solid var(--hairline)",
            }}
          >
            <img src={facebookIcon} alt="Facebook" style={{ width: 18, height: 18 }} />
          </a>
                

        </div>
      </div>

      {/* BOTTOM LINKS ROW */}
      <div
        className="container"
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr 1fr",
          gap: "1.5rem",
          marginTop: "-1rem",
        }}
      >
        {/* Product */}
        <div>
          <div style={{ fontWeight: 700, marginBottom: 10, color: "var(--ink)" }}>
            Product
          </div>
          <ul
            style={{
              listStyle: "none",
              padding: 0,
              display: "grid",
              gap: 8,
              color: "var(--ink-muted)",
            }}
          >
            <li><a href={homeHref}>Home</a></li>
            <li><a href={aboutHref}>About</a></li>

            {/* 🔵 JOIN → Opens modal */}
            <li>
              <a href="#join" onClick={handleJoinClick}>
                Join
              </a>
            </li>
          </ul>
        </div>

        {/* Company */}
        <div>
          <div style={{ fontWeight: 700, marginBottom: 10, color: "var(--ink)" }}>
            Company
          </div>
          <ul
            style={{
              listStyle: "none",
              padding: 0,
              display: "grid",
              gap: 8,
              color: "var(--ink-muted)",
            }}
          >
            <li><Link to="/contact">Contact</Link></li>
            {/* <li><a href="#">Careers</a></li>
            <li><a href="#">Press</a></li> */}
          </ul>
        </div>

        {/* Legal */}
        <div>
          <div style={{ fontWeight: 700, marginBottom: 10, color: "var(--ink)" }}>
            Legal
          </div>
          <ul
            style={{
              listStyle: "none",
              padding: 0,
              display: "grid",
              gap: 8,
              color: "var(--ink-muted)",
            }}
          >
            <li><Link to="/privacy">Privacy Policy</Link></li>
            <li><Link to="/terms">Terms of Service</Link></li>
            <li><Link to="/delete-account">Deleting Your Account</Link></li>
            {/* <li><a href="#">Cookies</a></li> */}
          </ul>
        </div>
      </div>

      {/* BOTTOM COPYRIGHT STRIP */}
      <div
        className="container"
        style={{
          marginTop: "1.25rem",
          color: "var(--ink-muted)",
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          gap: "6px",
        }}
      >
        <span style={{ fontWeight: 600 }}>
          © {y} BeFitFriends. All rights reserved.
        </span>
      </div>
      
      
    
     

    </footer>
  );
}
